<template>
  <div>
    <div v-if="loading" class="loader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <div v-else-if="emptyState">
      <div class="text-center">
        <p>
          <font-awesome-icon
            :icon="['fas', 'folder-open']"
            style="margin-right: 20px; font-size: 35px;"
          />
        </p>
        <h5>
          {{ this.$t('reports.inviteStatus.noDataLabel') }}
        </h5>
        <p>
          {{ this.$t('reports.inviteStatus.noDataMsg') }}
        </p>
      </div>
    </div>

    <div v-else>
      <div
        v-if="!this.userProfile.permissions.submits.anonymous_profile"
        class="summary"
      >
        <div class="summary-channel">
          <h1>{{ this.$t('reports.inviteStatus.emailLabel') }}</h1>

          <div class="container">
            <div
              @click="listDetails('email', 'all')"
              v-b-modal.modal-details
              :title="`${this.$t('reports.inviteStatus.invitesLabelInfoEmail')}`"
              class="item"
            >
              <header>
                <div class = "new-information" ><div class="info-icon-css"><i class="fas fa-info-circle"></i></div>
                <h2>
                  {{ this.$t('reports.inviteStatus.invitesLabel') }}
                </h2>
              </div>
              </header>

              <div class="description">
                <span>{{ summary.email.requests }}</span>
              </div>
            </div>
            <div
              @click="listDetails('email', 'delivered')"
              v-b-modal.modal-details
              :title="`${this.$t('reports.inviteStatus.deliveredLabelInfoEmail')}`"
              class="item"
            >
              <header>
                <div class = "new-information" ><div class="info-icon-css"><i class="fas fa-info-circle"></i></div>
                <h2>{{ this.$t('reports.inviteStatus.deliveredLabel') }}</h2>
              </div>
              </header>
              <div class="description">
                <span style="color: green;">{{
                  calculateAvarage(
                    summary.email.delivered,
                    summary.email.requests,
                  )
                }}</span>
                <span>{{ summary.email.delivered }}</span>
              </div>
            </div>
            <div
              @click="listDetails('email', 'open')"
              v-b-modal.modal-details
              :title="`${this.$t('reports.inviteStatus.openedLabelInfo')}`"
              class="item"
            >
              <header>
                <div class = "new-information" ><div class="info-icon-css"><i class="fas fa-info-circle"></i></div>
                <h2>{{ this.$t('reports.inviteStatus.openedLabel') }}</h2>
                </div>
              </header>
              <div class="description">
                <span style="color: rgb(62, 131, 177);">{{
                  calculateAvarage(summary.email.opened, summary.email.requests)
                }}</span>
                <span>{{ summary.email.opened }}</span>
              </div>
            </div>
            <div
              @click="listDetails('email', 'click')"
              v-b-modal.modal-details
              :title="`${this.$t('reports.inviteStatus.clickedLabelInfo')}`"
              class="item"
            >
              <header>
                <div class = "new-information" ><div class="info-icon-css"><i class="fas fa-info-circle"></i></div>
                <h2>{{ this.$t('reports.inviteStatus.clickedLabel') }}</h2>
                </div>
              </header>
              <div class="description">
                <span style="color: rgb(134, 196, 236);">{{
                  calculateAvarage(
                    summary.email.clicked,
                    summary.email.requests,
                  )
                }}</span>
                <span>{{ summary.email.clicked }}</span>
              </div>
            </div>
            <div
              @click="listDetails('email', 'bounce')"
              v-b-modal.modal-details
              :title="`${this.$t('reports.inviteStatus.bounceLabelInfo')}`"
              class="item"
            >
              <header>
                <div class = "new-information" ><div class="info-icon-css"><i class="fas fa-info-circle"></i></div>
                <h2>{{ this.$t('reports.inviteStatus.bounceLabel') }}</h2>
                </div>
              </header>
              <div class="description">
                <span style="color: rgb(207, 134, 236);">{{
                  calculateAvarage(
                    summary.email.bounced,
                    summary.email.requests,
                  )
                }}</span>
                <span>{{ summary.email.bounced }}</span>
              </div>
            </div>
            <div
              @click="listDetails('email', 'spamreport')"
              v-b-modal.modal-details
              :title="`${this.$t('reports.inviteStatus.spamLabelInfo')}`"
              class="item"
            >
              <header>
                <div class = "new-information" ><div class="info-icon-css"><i class="fas fa-info-circle"></i></div>
                <h2>{{ this.$t('reports.inviteStatus.spamLabel') }}</h2>
                </div>
              </header>
              <div class="description">
                <span style="color: red;">{{
                  calculateAvarage(
                    summary.email.spamReport,
                    summary.email.requests,
                  )
                }}</span>
                <span>{{ summary.email.spamReport }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="summary-channel">
          <h1>{{ this.$t('reports.inviteStatus.smsLabel') }}</h1>
          <div class="container">
            <div
              @click="listDetails('sms', 'all')"
              v-b-modal.modal-details
              :title="`${this.$t('reports.inviteStatus.invitesLabelInfoSMS')}`"
              class="item"
            >
              <header>
                <div class = "new-information" ><div class="info-icon-css"><i class="fas fa-info-circle"></i></div>
                <h2>{{ this.$t('reports.inviteStatus.invitesLabel') }}</h2>
                </div>
              </header>
              <div class="description">
                <span>{{ summary.sms.requests }}</span>
              </div>
            </div>
            <div
              @click="listDetails('sms', 'delivered')"
              v-b-modal.modal-details
              :title="`${this.$t('reports.inviteStatus.deliveredLabelInfoSMS')}`"
              class="item"
            >
              <header>
                <div class = "new-information" ><div class="info-icon-css"><i class="fas fa-info-circle"></i></div>
                <h2>{{ this.$t('reports.inviteStatus.deliveredLabel') }}</h2>
                </div>
              </header>
              <div class="description">
                <span style="color: green;">{{
                  calculateAvarage(summary.sms.delivered, summary.sms.requests)
                }}</span>
                <span>{{ summary.sms.delivered }}</span>
              </div>
            </div>
            <div
              @click="listDetails('sms', 'Not Received')"
              v-b-modal.modal-details
              :title="`${this.$t('reports.inviteStatus.notDeliveredLabelInfo')}`"
              class="item"
            >
              <header>
                <div class = "new-information" ><div class="info-icon-css"><i class="fas fa-info-circle"></i></div>
                <h2>{{ this.$t('reports.inviteStatus.notDeliveredLabel') }}</h2>
                </div>
              </header>
              <div class="description">
                <span style="color: red;">{{
                  calculateAvarage(
                    summary.sms.notReceived,
                    summary.sms.requests,
                  )
                }}</span>
                <span>{{ summary.sms.notReceived }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="summary">
        <div class="summary-channel">
          <h1>{{ this.$t('reports.inviteStatus.emailLabel') }}</h1>

          <div class="container">
            <div
              @click="listDetails('email', 'all')"
              v-b-modal.anonymous
              :title="`${this.$t('reports.inviteStatus.seeDetailsLabel')}`"
              class="item"
            >
              <header>
                <div class = "new-information" ><div class="info-icon-css"><i class="fas fa-info-circle"></i></div>
                <h2>
                  {{ this.$t('reports.inviteStatus.invitesLabel') }}
                </h2>
                </div>
              </header>

              <div class="description">
                <span>{{ summary.email.requests }}</span>
              </div>
            </div>
            <div
              @click="listDetails('email', 'delivered')"
              v-b-modal.anonymous
              :title="`${this.$t('reports.inviteStatus.seeDetailsLabel')}`"
              class="item"
            >
              <header>
                <div class = "new-information" ><div class="info-icon-css"><i class="fas fa-info-circle"></i></div>
                <h2>{{ this.$t('reports.inviteStatus.deliveredLabel') }}</h2>
                </div>
              </header>
              <div class="description">
                <span style="color: green;">{{
                  calculateAvarage(
                    summary.email.delivered,
                    summary.email.requests,
                  )
                }}</span>
                <span>{{ summary.email.delivered }}</span>
              </div>
            </div>
            <div
              @click="listDetails('email', 'open')"
              v-b-modal.anonymous
              :title="`${this.$t('reports.inviteStatus.seeDetailsLabel')}`"
              class="item"
            >
              <header>
                <h2>{{ this.$t('reports.inviteStatus.openedLabel') }}</h2>
              </header>
              <div class="description">
                <span style="color: rgb(62, 131, 177);">{{
                  calculateAvarage(summary.email.opened, summary.email.requests)
                }}</span>
                <span>{{ summary.email.opened }}</span>
              </div>
            </div>
            <div
              @click="listDetails('email', 'click')"
              v-b-modal.anonymous
              :title="`${this.$t('reports.inviteStatus.seeDetailsLabel')}`"
              class="item"
            >
              <header>
                <h2>{{ this.$t('reports.inviteStatus.clickedLabel') }}</h2>
              </header>
              <div class="description">
                <span style="color: rgb(134, 196, 236);">{{
                  calculateAvarage(
                    summary.email.clicked,
                    summary.email.requests,
                  )
                }}</span>
                <span>{{ summary.email.clicked }}</span>
              </div>
            </div>
            <div
              @click="listDetails('email', 'bounce')"
              v-b-modal.anonymous
              :title="`${this.$t('reports.inviteStatus.seeDetailsLabel')}`"
              class="item"
            >
              <header>
                <h2>{{ this.$t('reports.inviteStatus.bounceLabel') }}</h2>
              </header>
              <div class="description">
                <span style="color: rgb(207, 134, 236);">{{
                  calculateAvarage(
                    summary.email.bounced,
                    summary.email.requests,
                  )
                }}</span>
                <span>{{ summary.email.bounced }}</span>
              </div>
            </div>
            <div
              @click="listDetails('email', 'spamreport')"
              v-b-modal.anonymous
              :title="`${this.$t('reports.inviteStatus.seeDetailsLabel')}`"
              class="item"
            >
              <header>
                <h2>{{ this.$t('reports.inviteStatus.spamLabel') }}</h2>
              </header>
              <div class="description">
                <span style="color: red;">{{
                  calculateAvarage(
                    summary.email.spamReport,
                    summary.email.requests,
                  )
                }}</span>
                <span>{{ summary.email.spamReport }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="summary-channel">
          <h1>{{ this.$t('reports.inviteStatus.smsLabel') }}</h1>
          <div class="container">
            <div
              @click="listDetails('sms', 'all')"
              v-b-modal.anonymous
              :title="`${this.$t('reports.inviteStatus.seeDetailsLabel')}`"
              class="item"
            >
              <header>
                <div class = "new-information" ><div class="info-icon-css"><i class="fas fa-info-circle"></i></div>
                <h2>{{ this.$t('reports.inviteStatus.invitesLabel') }}</h2>
                </div>
              </header>
              <div class="description">
                <span>{{ summary.sms.requests }}</span>
              </div>
            </div>
            <div
              @click="listDetails('sms', 'delivered')"
              v-b-modal.anonymous
              :title="`${this.$t('reports.inviteStatus.seeDetailsLabel')}`"
              class="item"
            >
              <header>
                <h2>{{ this.$t('reports.inviteStatus.deliveredLabel') }}</h2>
              </header>
              <div class="description">
                <span style="color: green;">{{
                  calculateAvarage(summary.sms.delivered, summary.sms.requests)
                }}</span>
                <span>{{ summary.sms.delivered }}</span>
              </div>
            </div>
            <div
              @click="listDetails('sms', 'Not Received')"
              v-b-modal.anonymous
              :title="`${this.$t('reports.inviteStatus.seeDetailsLabel')}`"
              class="item"
            >
              <header>
                <h2>{{ this.$t('reports.inviteStatus.notDeliveredLabel') }}</h2>
              </header>
              <div class="description">
                <span style="color: red;">{{
                  calculateAvarage(
                    summary.sms.notReceived,
                    summary.sms.requests,
                  )
                }}</span>
                <span>{{ summary.sms.notReceived }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <highcharts :options="chartOptions" class="mt-4" />
    </div>

    <b-modal id="anonymous" title="Ops..."
      ><p>Seu perfil não tem acesso a esse detalhamento!</p></b-modal
    >

    <b-modal
      id="modal-details"
      size="lg"
      :cancel-title="`${this.$t('reports.cancelLabel')}`"
      @hidden="closeModal"
    >
      <template #modal-title>
        {{ getTitle() }}

        <template v-if="info === 'bounce'">
          <span id="popover-info">
            <font-awesome-icon
              :icon="['fas', 'info-circle']"
              style="font-size: 15px; color: #c1c1c1;"
            />
          </span>

          <b-popover target="popover-info" triggers="hover" placement="top">
            <template v-slot:title>{{ $t('reports.bounceEmail') }}</template>
            <span>{{ $t('reports.invalidAccount') }}</span
            ><br />
            <span>{{ $t('reports.invalidDomain') }}</span
            ><br />
            <span>{{ $t('reports.mailBoxFull') }}</span
            ><br />
            <span>{{ $t('reports.antiSpamBlocking') }}</span
            ><br />
            <span>{{ $t('reports.accountUnavailable') }}</span
            ><br />
            <span>{{ $t('reports.unavailableServer') }}</span
            ><br />
            <span>{{ $t('reports.deliveryFailure') }}</span
            ><br />
          </b-popover>
        </template>
      </template>
      <div class="row">
        <div class="col-6">
          <div class="search-invites">
            <input
              type="text"
              class="form-control"
              :placeholder="`${this.$t('reports.searchInput')}...`"
              v-model="filter"
              @keyup="searchByFilter"
            />
            <button @click="cleanFilter" class="btn btn-outline-primary">
              {{ this.$t('reports.searchButton') }}
            </button>
          </div>
        </div>
        <div class="col-6" style="text-align: right;">
          <button
            style="border: none; background: none;"
            :title="`${this.$t('actionList.actionDetails.titleExportXLS')}`"
            @click="download('xlsx')"
            :disabled="loadingDownloadButtons"
          >
            <span class="xls">
              <i class="fas fa-file-download"></i>
            </span>
          </button>
        </div>
      </div>

      <b-table
        striped
        id="status-invites-table"
        class="mt-3"
        :fields="fields"
        :items="inviteDetails.items"
        :busy="loadingTable"
        responsive
      >
        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner type="grow" class="align-middle"></b-spinner>
          </div>
        </template>
        <template v-slot:cell(statusDetailMessage)="row">
            {{ translateText(row.item.statusDetailMessage)}}
        </template>
      </b-table>

      <div v-show="!loadingTable" class="pagination-area-status-invites">
        <paginate
          v-model="page"
          :pageCount="Math.ceil(inviteDetails.total / limit)"
          :clickHandler="listDetails"
          :prevText="'‹'"
          :nextText="'›'"
          :activeClass="'active'"
          :containerClass="'pagination b-pagination'"
          :pageClass="'page-item'"
        >
        </paginate>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { format } from 'date-fns';
import Paginate from 'vuejs-paginate';
// eslint-disable-next-line no-unused-vars
import swal from 'sweetalert';
import api from '../../../../services/api';

export default {
  name: 'SubmitStatusReport',

  components: { Paginate },

  data: () => ({
    loading: false,
    loadingTable: false,
    emptyState: false,
    userAuth: null,
    filter: null,
    page: 1,
    limit: 10,
    channel: null,
    status: null,
    inviteDetails: {
      total: 0,
      items: [],
    },
    fields: [],
    summary: {
      sms: {
        requests: 0,
        delivered: 0,
        notReceived: 0,
        lastStatus: '-',
      },
      email: {
        requests: 0,
        delivered: 0,
        opened: 0,
        clicked: 0,
        bounced: 0,
        spamReport: 0,
      },
    },
    chartOptions: {},
    loadingDownloadButtons: false,
    info: null,
  }),

  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.loadChart();
    },

    myActionId: function watchmyActionId() {
      this.loadChart();
    },

    myActionsIds: function watchmyActionsIds() {
      this.loadChart();
    },

    calendarDates: function watchCalendarDates() {
      this.loadChart();
    },

    myIh1: function watchMyIh1() {
      this.loadChart();
    },

    myHierarchies1: function watchMyHierarchies1(){
      this.loadChart();
    },

    myIh2: function watchMyIh2() {
      this.loadChart();
    },

    myHierarchies2: function watchMyHierarchies2(){
      this.loadChart();
    },

    myMetric: function watchMyMetric() {
      this.loadChart();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.loadChart();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.loadChart();
    },
  },

  methods: {
    translateText(text){
      if(text === 'Message received by mobile'){
        return 'Mensagem recebida pelo mobile'
      }

      return text;
    },

    getMonthName(month) {
      // eslint-disable-next-line
      const monthNames = this.$i18n.messages[this.$i18n.locale].reports.fullMonthNames;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < monthNames.length; i++) {
        if (monthNames[i].key.toLowerCase() === month.toLowerCase()) {
          return monthNames[i].value;
        }
      }
      return null;
    },
    async loadChart() {
      this.loading = true;
      this.emptyState = false;

      const response = await api.get('/status/invites', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        },
      });

      this.chartOptions.xAxis.categories = response.data.chartData.categories;
      this.chartOptions.series[0].data = response.data.chartData.email;
      this.chartOptions.series[1].data = response.data.chartData.sms;

      if (this.chartOptions.xAxis.categories.length === 0) {
        this.emptyState = true;
      } else {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.chartOptions.xAxis.categories.length; i++) {
          this.chartOptions.xAxis.categories[i] = this.getMonthName(
            this.chartOptions.xAxis.categories[i],
          );
        }
      }

      this.summary = response.data.summary;

      this.loading = false;
    },

    async listDetails(channel, status) {
      this.loadingTable = true;

      if (channel && status) {
        this.channel = channel;

        if (status === 'all') {
          this.status = null;
        } else {
          this.status = status;
        }
      }

      if (this.channel === 'email') {
        this.fields[2] = {
          key: 'email',
          label: this.$t('reports.inviteStatus.emailLabel'),
        };
      } else {
        this.fields[2] = {
          key: 'phone',
          label: this.$t('reports.inviteStatus.phoneLabel'),
        };
      }

      if (this.channel === 'sms') {
        this.fields[4] = {
          key: 'statusDetailMessage',
          label: 'Último status',
        };
      }

      const response = await api.get(`/status/invites/${this.channel}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          page: this.page,
          limit: this.limit,
          status: this.status,
          filter: this.filter,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        },
      });

      this.inviteDetails.items = response.data.items;
      this.inviteDetails.total = response.data.total;

      this.inviteDetails.items.forEach((invite) => {
        invite.createdAt = format(
          new Date(invite.createdAt),
          'dd/MM/yyyy HH:mm',
        );
      });

      this.loadingTable = false;
    },

    getTitle() {
      let value = '';

      switch (this.status) {
        case 'delivered':
          value = this.$t('reports.inviteStatus.detailDeliveredLabel');
          this.info = null;
          break;
        case 'open':
          value = this.$t('reports.inviteStatus.detailOpenedLabel');
          this.info = null;
          break;
        case 'click':
          value = this.$t('reports.inviteStatus.detailClickedLabel');
          this.info = null;
          break;
        case 'bounce':
          value = this.$t('reports.inviteStatus.detailBounceLabel');
          this.info = 'bounce';
          break;
        case 'spamreport':
          value = this.$t('reports.inviteStatus.detailSpamLabel');
          this.info = null;
          break;
        case 'not received':
          value = this.$t('reports.inviteStatus.detailNotReceivedLabel');
          break;
        default:
          value = this.$t('reports.inviteStatus.detailDefaultLabel');
          this.info = null;
          break;
      }

      return value;
    },

    searchByFilter() {
      if (this.filter !== '' && this.filter !== null) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.listDetails, 600);
      }
      if (this.filter === '') {
        this.filter = null;
        this.listDetails();
      }
    },

    cleanFilter() {
      this.filter = null;
      this.listDetails();
    },

    closeModal() {
      this.channel = null;
      this.status = null;

      this.inviteDetails.items = [];
      this.inviteDetails.total = 0;

      this.filter = null;
      this.page = 1;
    },

    calculateAvarage(dividend, divider) {
      if (!dividend || !divider) {
        return '0%';
      }

      return `${Number(((dividend / divider) * 100).toFixed(2))}%`;
    },
    // eslint-disable-next-line no-unused-vars
    async download(type) {
      this.loadingDownloadButtons = true;

      if (this.inviteDetails.items.length > 0) {
        try {
          await api.get(`status-download/invites/${this.channel}`, {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              status: this.status,
              channel: this.channel,
              filter: this.filter,
              actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
              startDate: this.calendarDates.start,
              endDate: this.calendarDates.end,
              ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
              ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
              metric: this.myMetric,
              groupId: this.actionGroupData._id,
              indicator: this.indicatorName,
              indicatorValue: this.indicatorData.value,
              indicatorRange: this.indicatorData.range,
            },
          });

          swal({
            title: `${this.$t(
              'actionList.actionDetails.alertsActionDetails.succes.title',
            )}`,
            text: `${this.$t(
              'actionList.actionDetails.alertsActionDetails.succes.description',
            )}`,
            icon: 'success',
          });
        } catch (error) {
          swal({
            title: 'Oops...',
            text: error.response.data.message,
            icon: 'error',
          });
        }
      }

      this.loadingDownloadButtons = false;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fields = [
      {
        key: 'controlId',
        label: this.$t('reports.inviteStatus.inviteIdLabel'),
      },
      { key: 'name', label: this.$t('reports.inviteStatus.customerLabel') },
      { key: 'email', label: this.$t('reports.inviteStatus.emailLabel') },
      {
        key: 'createdAt',
        label: this.$t('reports.inviteStatus.sentDateLabel'),
      },
    ];
    this.chartOptions = {
      title: {
        text: `${this.$t('reports.inviteStatus.emailLabel')} (%)`,
      },
      chart: {
        type: 'column',
      },
      xAxis: {
        categories: [],
        labels: {},
      },
      yAxis: {
        min: 0,
        gridLineWidth: 0,
        labels: {
          enabled: false,
        },
        title: {
          text: '',
        },
      },
      series: [
        {
          name: this.$t('reports.inviteStatus.emailLabel'),
          data: [1, 2],
          label: true,
        },
        {
          name: this.$t('reports.inviteStatus.smsLabel'),
          data: [1, 2],
          label: true,
        },
      ],
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
          },
        },
      },
    };
  },

  async mounted() {
    this.loading = true;

    await this.loadChart();

    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.summary {
  display: flex;
  flex-direction: row;

  h1 {
    font-size: 16px;
  }

  .summary-channel {
    display: flex;
    flex-direction: column;
    padding: 5px;

    .container {
      border: 0;
      padding: 0;
      display: flex;
      flex-direction: row;

      .item {
        display: flex;
        flex-direction: column;
        padding: 5px 8px;
        margin-right: 10px;
        min-height: 79px;
        max-height: 79px;
        min-width: 115px;
        max-width: 115px;
        -webkit-box-shadow: 0px 0px 9px -6px #000000;
        box-shadow: 0px 0px 9px -6px #000000;
        transition: 0.3s;

        cursor: pointer;

        &:hover {
          -webkit-box-shadow: 0px 0px 12px -6px #000000;
          box-shadow: 0px 0px 12px -6px #000000;
        }

        header {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-transform: uppercase;

          h2 {
            font-size: 11px;
          }
        }

        .description {
          display: flex;
          flex-direction: column;
          flex: 1;
          justify-content: center;
          align-items: center;

          span {
            font-size: 22px;
            font-weight: lighter;

            & + span {
              margin-top: -3px;
              font-size: 12px;
            }
          }
        }

        &:last-of-type {
          margin-right: 30px;
        }

        .new-information{
          display: flex;

        }
        .info-icon-css{
          margin-right: 5px;
          font-size: 10px
        }

      }
    }
  }
}

.search-invites {
  display: flex;
  flex-direction: row;
  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}

.loader {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.detractor-review {
  display: flex;
  justify-content: center;
  align-items: center;

  background: red;
  color: white;
  height: 30px;
  width: 30px;
  border-radius: 50%;
}

.pagination-area-status-invites >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.xls:hover {
  color: #1dc86e;
}

@media (max-width: 1310px) {
  .summary {
    flex-direction: column;
  }
}
</style>

<style>
.pagination-area-status-invites .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-status-invites a {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/invite-status/index.vue